import { render, staticRenderFns } from "./PageContainer.vue?vue&type=template&id=11718cf4&scoped=true&"
import script from "./PageContainer.vue?vue&type=script&lang=js&"
export * from "./PageContainer.vue?vue&type=script&lang=js&"
import style0 from "./PageContainer.vue?vue&type=style&index=0&id=11718cf4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11718cf4",
  null
  
)

export default component.exports